import Api from '../api';

const USERS = '/users';
const PANDADOC = '/pandadoc/documents';

export type CreateVendorDocumentData =
  | {
      tax_classification: string;
      address: string;
      address_2: string;
      city: string;
      state: string;
      zip: string;
      tax_id: string;
      is_individual: boolean;
      legal_name: string;
    }
  | {
      tax_classification: string;
      first_name: string;
      last_name: string;
      middle_name: string;
      address: string;
      address_2: string;
      city: string;
      state: string;
      zip: string;
      tax_id: string;
      is_individual: boolean;
    }
  | {
      first_name: string;
      last_name: string;
      middle_name: string;
      country: string;
      address: string;
      address_2: string;
      city: string;
      state: string;
      zip: string;
      payment_billing_address: string;
      payment_billing_address_2: string;
      payment_country: string;
      payment_state: string;
      payment_city: string;
      payment_zip: string;
      is_individual: boolean;
    }
  | {
      legal_name: string;
      address: string;
      address_2: string;
      city: string;
      state: string;
      zip: string;
      payment_country: string;
      payment_billing_address: string;
      payment_billing_address_2: string;
      payment_city: string;
      payment_state: string;
      payment_zip: string;
      country: string;
    };

const VendorPandadocAPI = {
  getVendorDocument(userId: number, documentName: string) {
    return Api.get(`${USERS}/${userId}${PANDADOC}/${documentName}`);
  },

  createVendorDocument(
    userId: number,
    documentName: string,
    data: CreateVendorDocumentData,
  ) {
    return Api.post(`${USERS}/${userId}${PANDADOC}/${documentName}`, {
      data,
    });
  },

  createDocumentLink(userId: number, pandadocId: string) {
    return Api.post(`${USERS}/${userId}${PANDADOC}/link/${pandadocId}`);
  },
};

export default VendorPandadocAPI;
